import './basketMulticottage.css';

const bookingFormModule = () => import(/* webpackChunkName: 'components/bookingForm' */'../bookingForm/bookingForm');

import { basketTpl } from './basketTpl';
import { popinCleanBasketTpl } from '../popinCleanBasket/popinCleanBasketTpl';
import { cartoucheMultiCottageProduct } from '../cartoucheMultiCottageProduct/cartoucheMultiCottageProduct';

export const BasketMulticottageView = Backbone.View.extend({
  initialize: function () {
    if (sessionStorage.getItem('basketDatas') !== null) {
      this.renderBasket();
    }

    $('.js-basketMulticottage').off().on('click', (e) => {
      e.preventDefault();
      this.addBasket(e);
    });

    let cachedWidth = $(window).width();
    let cachedHeight = $(window).height();

    $(window).on('resize', () => {
      let newWidth = $(window).width();
      let newHeight = $(window).height();

      if ((newWidth !== cachedWidth || newHeight !== cachedHeight) && sessionStorage.getItem('basketDatas') !== null && DEVICE.isMobile) {
        $('.basket-container, .basket-openerMobile').remove();
        this.renderBasket();
      }
    });

    this.listenTo(dispatcher, 'basket:addBasket', this.addBasket, event);
  },

  renderBasket: function () {
    const basketDatas = JSON.parse(sessionStorage.getItem('basketDatas'));
    const hasFirstCottage = basketDatas.cottagesSelected[0].isFilled;
    const hasSecondCottage = basketDatas.cottagesSelected.length > 1 && basketDatas.cottagesSelected[1].isFilled;

    let datasBasketTosend = {
      siteName: basketDatas.siteName,
      nbParticipants: basketDatas.nbParticipants,
      dateStart: basketDatas.dateStart,
      dateEnd: basketDatas.dateEnd,
      productCode: basketDatas.productCode,
      housingCode: basketDatas.housingCode,
      domaincode: basketDatas.domaincode,
      portalCode: basketDatas.portalCode,
      duration: basketDatas.duration,
      currency: GLOBAL_SCRIPTS.CURRENCY_CODE,
      symbol: GLOBAL_SCRIPTS.CURRENCY_SYMBOL,
      cottagesSelected: [{
        isFilled: false
      }, {
        isFilled: false
      }],
      multiParticipants: [{
        adult: basketDatas.multiParticipants[0].adult,
        senior: basketDatas.multiParticipants[0].senior,
        children: basketDatas.multiParticipants[0].children,
        pet: basketDatas.multiParticipants[0].pet,
        ages: basketDatas.multiParticipants[0].ages
      }, {
        adult: basketDatas.multiParticipants[1].adult ? basketDatas.multiParticipants[1].adult : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].adults : '',
        senior: basketDatas.multiParticipants[1].senior ? basketDatas.multiParticipants[1].senior : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].seniors : '',
        children: basketDatas.multiParticipants[1].children ? basketDatas.multiParticipants[1].children : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].ages.length : '',
        pet: basketDatas.multiParticipants[1].pet ? basketDatas.multiParticipants[1].pet : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].pets : '',
        ages: basketDatas.multiParticipants[1].ages ? basketDatas.multiParticipants[1].ages : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].ages : ''
      }],
      openBasket: $('.domainAccommodations-roomTabContent').length ? false : hasFirstCottage && hasSecondCottage ? true : basketDatas.openBasket,
      translateOpening: !(hasFirstCottage && hasSecondCottage) ? false : true
    };

    let cottage = [hasFirstCottage, hasSecondCottage];

    for (let i = 0; i < cottage.length; ++i) {
      const datasCottage = JSON.parse(sessionStorage.getItem('basketDatas')).cottagesSelected[i];

      if (cottage[i]) {
        datasBasketTosend.cottagesSelected[i] = {
          isFilled: true,
          housingCode: datasCottage.housingCode,
          cottageDetailUrl: datasCottage.cottageDetailUrl,
          cottageLabel: datasCottage.cottageLabel,
          originalPrice: datasCottage.originalPrice,
          originalPriceRawBeforeTax: datasCottage.originalPriceRawBeforeTax,
          discountPrice: datasCottage.discountPrice,
          pricePromo: datasCottage.pricePromo,
          photoDomainUrl: datasCottage.photoDomainUrl,
          actionCode: datasCottage.actionCode,
          discountLabel: datasCottage.discountLabel,
          maxPersons: datasCottage.maxPersons,
          price: datasCottage.price,
          includedServices: datasCottage.includedServices
        };
        datasBasketTosend.sideBySide = basketDatas.sideBySide;
      }
    }

    let htmlBasketMulticottage = basketTpl(datasBasketTosend);

    sessionStorage.setItem('basketDatas', JSON.stringify(datasBasketTosend));
    $('.basket-container, .basket-openerMobile').remove();
    $('#mainContainer').append(htmlBasketMulticottage);

    // Update search panel
    const dateStart = genericDate.toDisplay(new Date(basketDatas.dateStart));
    const dateEnd = genericDate.toDisplay(new Date(basketDatas.dateEnd));

    $('.js-search-date_begin').val(dateStart).removeClass('disabled').removeAttr('disabled');
    $('.js-search-date_end').val(dateEnd).removeClass('disabled').removeAttr('disabled');

    // Update date for mobile view
    if (DEVICE.isMobile) {
      dispatcher.trigger('search:toggler:updateDates', dateStart, dateEnd);
    }

    $('.js-pika-reset').addClass('visible');

    // Display basket
    this.displayBasket();

    // Init booking form
    if (hasFirstCottage && hasSecondCottage) {
      bookingFormModule().then(({BookingForm}) => {
        new BookingForm();
      });
    }

    dispatcher.trigger('facette:dates:updateDateFieldLabel',new Date(basketDatas.dateStart), '.js-search-arrivalDay');
    dispatcher.trigger('facette:dates:updateDateFieldLabel', new Date(basketDatas.dateEnd), '.js-search-departureDay');

    // Display cartouche product
    if (GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' || (GLOBAL_SCRIPTS.CONTROLLER === 'product' && PRODUCT_SCRIPTS.PRODUCT_TAB ===  (GLOBAL_SCRIPTS.UNIVERS === 'fba' ? 'tab_fba_cottages' : GLOBAL_SCRIPTS.UNIVERS === 'sp' ? 'tab_sp_cottages' : 'tab_cpe_cottages'))) {
      this.displayCartoucheProduct();
    }

    // Events basket
    this.eventBasket();
    this.checkLink();
  },

  addBasket: function (e) {
    const $basketContainer = $('.basket-container');
    const $currentTarget = $(e.currentTarget);
    const hasBasket = JSON.parse(sessionStorage.getItem('basketDatas')) !== null;
    const datasBasket = JSON.parse(sessionStorage.getItem('basketDatas'));
    const hasFirstCottage = sessionStorage.getItem('basketDatas') !== null && datasBasket.cottagesSelected[0].isFilled;
    const hasSecondCottage = sessionStorage.getItem('basketDatas') !== null && datasBasket.cottagesSelected.length > 1 && datasBasket.cottagesSelected[1].isFilled;
    const datascottageFirst = hasFirstCottage ? datasBasket.cottagesSelected[0] : {isFilled: false};
    const datascottageSecond = hasSecondCottage ? datasBasket.cottagesSelected[1] : {isFilled: false};
    const labelDomainSck = $currentTarget.parents('.cartoucheDomain-container').length ? $currentTarget.parents('.cartoucheDomain-container').find('.titleDomain').html() : $currentTarget.parents('.accCart').find('.titleDomain').html();
    const isInPopin = $currentTarget.parents('#js-popinCottageDetails').length > 0;
    /* GET DATAS TO SEND */
    const datasBasketTosend = {
      openBasket: true,
      siteName: typeof PRODUCT_SCRIPTS !== 'undefined' ? PRODUCT_SCRIPTS.SITENAME : labelDomainSck,
      domaincode: $currentTarget.data().domaincode,
      nbParticipants: hasFirstCottage ? datasBasket.nbParticipants : typeof this.attributes !== 'undefined' ? this.attributes.totalParticipants : SEARCH_SCRIPTS.TOTALPARTICIPANTS,
      dateStart: $currentTarget.data().start,
      dateEnd: $currentTarget.data().end,
      duration: $currentTarget.data().duration,
      productCode: $currentTarget.data().code,
      housingCode: $currentTarget.data().housingcode,
      portalCode: typeof SEARCH_SCRIPTS !== 'undefined' ? SEARCH_SCRIPTS.PORTAL_CODE : '',
      actionCode: $currentTarget.data().actioncodecode,
      currency: GLOBAL_SCRIPTS.CURRENCY_CODE,
      symbol: GLOBAL_SCRIPTS.CURRENCY_SYMBOL,
      cottagesSelected: [],
      multiParticipants: [{
        adult: hasBasket ? datasBasket.multiParticipants[0].adult : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[0].adults : $currentTarget.data().adultsnb,
        senior: hasBasket ? datasBasket.multiParticipants[0].senior : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[0].seniors : $currentTarget.data().seniorsnb,
        children: hasBasket ? datasBasket.multiParticipants[0].children : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[0].ages.length : $currentTarget.data().childrennb,
        pet: hasBasket ? datasBasket.multiParticipants[0].pet : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[0].pets : $currentTarget.data().petsnb,
        ages: hasBasket ? datasBasket.multiParticipants[0].ages : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[0].ages : $currentTarget.data().ages
      }, {
        adult: hasBasket ? datasBasket.multiParticipants[1].adult : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].adults : !isInPopin ? $currentTarget.data().adultsnb : false,
        senior: hasBasket ? datasBasket.multiParticipants[1].senior : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].seniors : !isInPopin ? $currentTarget.data().seniorsnb : false,
        children: hasBasket ? datasBasket.multiParticipants[1].children : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].ages.length : !isInPopin ? $currentTarget.data().childrennb : false,
        pet: hasBasket ? datasBasket.multiParticipants[1].pet : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].pets : !isInPopin ? $currentTarget.data().petsnb : false,
        ages: hasBasket ? datasBasket.multiParticipants[1].ages : typeof this.attributes !== 'undefined' ? this.attributes.multiparticipants[1].ages : !isInPopin ? $currentTarget.data().ages : false
      }]
    };
    const targetDataset = {
      isFilled: true,
      housingCode: $currentTarget.data().housingcode,
      cottageLabel: $currentTarget.data().cottagename,
      originalPrice: $currentTarget.data().priceoriginal,
      originalPriceRawBeforeTax: $currentTarget.data().priceoriginalrawbeforetax,
      pricePromo: $currentTarget.data().pricepromo,
      discountPrice: $currentTarget.data().pricediscount,
      photoDomainUrl: $currentTarget.data().photodomainurl,
      actionCode: $currentTarget.data().actioncodecode,
      discountLabel: $currentTarget.data().actioncodename,
      maxPersons: $currentTarget.data().maxcapacity,
      cottageDetailUrl: $currentTarget.parent().find('.js-lightCottageDetails').data('src'),
      price: {
        originalPrice: $currentTarget.data().priceoriginal,
        originalPriceRawBeforeTax: $currentTarget.data().priceoriginalrawbeforetax,
        pricePromo: $currentTarget.data().pricepromo,
        priceDiscount: $currentTarget.data().pricediscount,
        rawDifference: $currentTarget.data().rawdifference,
        pricePetsValueBeforeTax: $currentTarget.data().pricepetsvaluebeforetax,
        pricePetsRawBeforeTax: $currentTarget.data().pricepetsrawbeforetax,
        taxTotal: $currentTarget.data().taxtotal
      },
      includedServices: $currentTarget.data().includedservices
    };

    if (hasFirstCottage && hasSecondCottage) {
      datasBasketTosend.cottagesSelected[0] = datascottageFirst;
      datasBasketTosend.cottagesSelected[1] = datascottageSecond;
    } else if (!hasFirstCottage || !hasSecondCottage) {
      datasBasketTosend.cottagesSelected[0] = hasFirstCottage ? datascottageFirst : $currentTarget.data().cottagetoselect === 1 ? targetDataset : {isFilled: false};
      datasBasketTosend.cottagesSelected[1] = hasSecondCottage ? datascottageSecond : $currentTarget.data().cottagetoselect === 2 ? targetDataset : {isFilled: false};
      datasBasketTosend.sideBySide = $currentTarget.data().sidebyside === 'true';
    } else {
      datasBasketTosend.cottagesSelected[0] = targetDataset;
    }

    sessionStorage.setItem('basketDatas', JSON.stringify(datasBasketTosend));

    $('.js-search-date_begin').val(genericDate.toDisplay(new Date($currentTarget.data().start))).removeClass('disabled').removeAttr('disabled');
    $('.js-search-date_end').val(genericDate.toDisplay(new Date($currentTarget.data().end))).removeClass('disabled').removeAttr('disabled');

    if (isInPopin) $('.js-closeFancybox').click();
    $('.nbParticipantsBasket').html(hasFirstCottage ? datasBasket.nbParticipants : SEARCH_SCRIPTS.TOTALPARTICIPANTS);

    if (GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' && $('.cartoucheDomain-container').length > 0 && $('.accCart-container:visible').length === 0) {
      $('.cartMulti, .cartMultiBlock').remove();
      dispatcher.trigger('search:resultList:render');
      $basketContainer.addClass(!DEVICE.isBigDesktop ? 'closed' : 'minimized');
    }

    $basketContainer.addClass('loading');

    dispatcher.trigger('searchModel:updateSearchParams');
    dispatcher.trigger('searchView:submitSearch', e);
    if (!DEVICE.isMobile) $('body').addClass('basketOpened');

    genericScrollTo.go('.searchbar', 500, 10);
  },

  deleteBasket: function (e) {
    $('.accCart-bookingButton').removeClass('disabled').find('.button').removeClass('disabled');
    const $basketContainer = $('.basket-container');
    const $basketOpenerMobile = $('.basket-openerMobile');
    const datasBasket = JSON.parse(sessionStorage.getItem('basketDatas'));

    let datasBasketTosend = {
      ...datasBasket,
      openBasket: false
    };

    datasBasketTosend.cottagesSelected[$(e.currentTarget).data('index') === 1 ? 0 : 1] = {
      isFilled: false,
      discountPrice: '',
      photoDomainUrl: '',
      housingCode: '',
      originalPrice: '',
      pricePromo: ''
    };

    if ((typeof datasBasketTosend.cottagesSelected[0] !== 'undefined' && datasBasketTosend.cottagesSelected[0].isFilled) || (typeof datasBasketTosend.cottagesSelected[1] !== 'undefined' && datasBasketTosend.cottagesSelected[1].isFilled)) {
      $basketContainer.addClass('disabled');
      $('body').addClass('basketOpened');
      sessionStorage.setItem('basketDatas', JSON.stringify(datasBasketTosend));
    } else {
      sessionStorage.removeItem('basketDatas');
      $('body').removeClass('basketOpened');
      $basketContainer.remove();
      $basketOpenerMobile.remove();
    }

    $basketContainer.addClass('loading');
    if (GLOBAL_SCRIPTS.CONTROLLER === 'product') {
      if (PRODUCT_SCRIPTS.PRODUCT_TAB === `tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages`) {
        dispatcher.trigger('searchView:submitSearch', e);
        genericScrollTo.go('.searchbar', 500, 10);
      } else {
        $(`#tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages .js-postParams`).click();
      }
    } else {
      dispatcher.trigger('searchView:submitSearch', e);
    }

    if (DEVICE.isMobile) $('html').removeClass('disableScrollMenuMobile');
  },

  displayBasket: function () {
    const $html = $('html');
    const $body = $('body');
    const $basketContainer = $('.basket-container');
    const basketDatas = JSON.parse(sessionStorage.getItem('basketDatas'));
    const hasFirstCottage = sessionStorage.getItem('basketDatas') !== null && basketDatas.cottagesSelected[0].isFilled;
    const hasSecondCottage = sessionStorage.getItem('basketDatas') !== null && basketDatas.cottagesSelected.length > 1 && basketDatas.cottagesSelected[1].isFilled;

    if (basketDatas.openBasket && hasFirstCottage && hasSecondCottage) {
      $body.addClass('basketOpened');
      $html.addClass('disableScrollMenuMobile');
      setTimeout(function () {
        $basketContainer.removeClass('translateOpening minimized closed');
      }, 200);
    } else if (basketDatas.openBasket && !$('.domainAccommodations-roomTabContent').length && (hasFirstCottage || hasSecondCottage)) {
      $html.addClass('disableScrollMenuMobile');
      $basketContainer.removeClass('translateOpening');
      $body.addClass('basketOpened');

      setTimeout(function() {
        $basketContainer.removeClass(!DEVICE.isBigDesktop ? 'closed' : 'minimized');
      }, 100);
    } else {
      $html.removeClass('disableScrollMenuMobile');
      $body.removeClass('basketOpened');
      $basketContainer.removeClass('translateOpening');

      setTimeout(function() {
        $basketContainer.addClass(!DEVICE.isBigDesktop ? 'closed' : 'minimized');
      }, 200);
    }
  },

  displayCartoucheProduct: function () {
    const $cartMultiProductBlock = $('.cartMultiProductBlock');
    const basketDatas = JSON.parse(sessionStorage.getItem('basketDatas'));
    const hasToDisplayCartProduct = !(GLOBAL_SCRIPTS.CONTROLLER === 'singleclick' && $('.cartoucheDomain-container').length > 0 && $('.accCart-container:visible').length === 0);
    const hasFirstCottage = basketDatas.cottagesSelected[0].isFilled;
    const hasSecondCottage = basketDatas.cottagesSelected.length > 1 && basketDatas.cottagesSelected[1].isFilled;

    let htmlCartoucheMultiCottage = '';

    $('.cartMultiProductBlock').remove();

    if (hasFirstCottage && hasSecondCottage) {
      htmlCartoucheMultiCottage = cartoucheMultiCottageProduct({
        title: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.addCottageTitleFilled
      });
      // Disable button when 2 cottages selected
      $('.accCart-bookingButton, .cotDet-bookingLink').addClass('disabled').removeClass('js-basketMulticottage');
      $('.accCart-bookingButton .button').addClass('disabled');
    } else if (hasFirstCottage || hasSecondCottage) {
      htmlCartoucheMultiCottage = cartoucheMultiCottageProduct({
        title: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.addCottageTitle + ' ' + (!hasFirstCottage ? 1 : 2),
        number: !hasFirstCottage ? '1' : '2',
        participants: basketDatas.multiParticipants[!hasFirstCottage ? 0 : 1]
      });
      $('.accCart-bookingButton').data('cottagetoselect', hasFirstCottage ? 2 : 1);
    } else {
      htmlCartoucheMultiCottage = cartoucheMultiCottageProduct({
        title: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.addCottageTitle + ' 1',
        number: '1',
        participants: basketDatas.multiParticipants[0]
      });
    }

    $cartMultiProductBlock.remove();
    if (hasToDisplayCartProduct) {
      if (!$('.cartoucheDomain-container').length) {
        $('.resultList-Header, .cotDet-bookingInfo').prepend(htmlCartoucheMultiCottage);
      } else {
        $('.accCartList').prepend(htmlCartoucheMultiCottage);
      }
    }
  },

  eventBasket: function () {
    const $html = $('html');
    const $body = $('body');
    const statusClass = !DEVICE.isBigDesktop ? 'closed' : 'minimized';

    $('.js-toggleBasket').off().on('click', (e) => {
      if (!$(e.currentTarget).parents('.basket-container').hasClass('minimized')) {
        Tracking.dataLayerPush({
          clickCode: '',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'popinbasket_' + $(e.currentTarget).find('.basket-domainName').html(),
          gaLabel: 'Explicit',
          event: 'clickEvent'
        });
      }

      if ($(e.currentTarget).hasClass('basket-cottageToSelect')) {
        Tracking.dataLayerPush({
          clickCode: '',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Add your accommodation ' + $(e.currentTarget).find('.basket-cottageToSelectIcon span').html(),
          gaLabel: 'accommodation name',
          event: 'clickEvent'
        });
      }
      this.toggleBasket();

      if (!DEVICE.isBigDesktop) {
        $html.removeClass('disableScrollMenuMobile');
        $body.toggleClass('basketOpened');
      }
    });

    $('.basket-openerMobile').on('click', () => {
      $html.addClass('disableScrollMenuMobile');
      $body.addClass('basketOpened');
      $('.basket-container').removeClass('closed');
    });

    $('.js-modify').on('click', (e) => {
      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'popinbasket_#' + $(e.currentTarget).parents('.basket-container').find('.basket-domainName').html(),
        gaLabel: 'modify',
        event: 'clickEvent'
      });

      if (GLOBAL_SCRIPTS.CONTROLLER === 'product') {
        if (PRODUCT_SCRIPTS.PRODUCT_TAB === `tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages`) {
          this.toggleBasket();
          genericScrollTo.go('.searchbar', 500, 10);
        } else {
          $(`#tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages a`).click();
        }
      } else {
        this.toggleBasket();
        genericScrollTo.go('.searchbar', 500, 10);
      }
    });

    // Listen for clicks on '.js-openDetails' elements, working for both current and future elements.
    $(document).off('click' , '.js-openDetails').on('click', '.js-openDetails', function (e) {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);
      const datasCottage = JSON.parse(sessionStorage.getItem('basketDatas')).cottagesSelected[$(e.currentTarget).closest('.basket-cottageSelected').hasClass('first') ? 0 : 1];
      $('.basket-container').addClass(statusClass);
      dispatcher.trigger('search:resultList:callLightDetails', datasCottage.cottageDetailUrl);

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'opens cottage info page_#' + $currentTarget.parents('.basket-container').find('.basket-domainName').html(),
        gaLabel: 'Implicit',
        event: 'clickEvent'
      });
    });

    $('.js-deleteBasket').off().on('click', (e) => {
      e.preventDefault();
      this.deleteBasket(e);

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'popinbasket_#' + $(e.currentTarget).parents('.basket-container').find('.basket-domainName').html(),
        gaLabel: 'remove',
        event: 'clickEvent'
      });
    });

    $('.js-goToCottage').on('click', (e) => {
      e.preventDefault();
      if (GLOBAL_SCRIPTS.CONTROLLER === 'product' && PRODUCT_SCRIPTS.PRODUCT_TAB !== `tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages`) {
        $(`#tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages a`).click();
      }
    });

    $('.cp-overlay').on('click', () => {
      $html.removeClass('disableScrollMenuMobile');
      $body.removeClass('basketOpened');
      $('.basket-container').addClass(statusClass);
    });

    const $buttonContainer = $('.basket-cottageToSelect');
    $('.basket-footer .button').on('mouseover', (e) => {
      const $currentTarget = $(e.currentTarget);
      if ($currentTarget.hasClass('disabled')) {
        $buttonContainer.addClass('hover');
      }
    }).on('mouseout', () => {
      $buttonContainer.removeClass('hover');
    });

    $('.js-postBasket').on('click', (e) => {
      e.preventDefault();
      $(e.currentTarget).closest('.basket-container').find('form').submit();
    });

    $('.js-searchForm-dataOpener, .js-domainSelector, .searchToggler-participants, .searchToggler-date').off().on('click', e => {
      if ((GLOBAL_SCRIPTS.CONTROLLER === 'product' || GLOBAL_SCRIPTS.CONTROLLER === 'singleclick') && sessionStorage.getItem('basketDatas') !== null) {
        if (DEVICE.isMobile && !$body.hasClass('basketOpened') || !DEVICE.isMobile) {
          this.popinResetSearch(e);
        }
      }
    });
  },

  toggleBasket: function () {
    const $basketContainer = $('.basket-container');
    const $body = $('body');
    const statusClass = !DEVICE.isBigDesktop ? 'closed' : 'minimized';

    $basketContainer.toggleClass(statusClass);

    if (DEVICE.isBigDesktop) {
      $body.toggleClass('basketOpened');
    } else {
      $body.removeClass('basketOpened body-searchMobileEngineOpen body-searchMobileEngineOpened');
    }

    $('.cp-overlay').on('click', () => {
      $('html').removeClass('disableScrollMenuMobile');
      $body.removeClass('basketOpened body-searchMobileEngineOpen body-searchMobileEngineOpened');
      $basketContainer.addClass(statusClass);
    });
  },

  checkLink: function () {
    // Manage popin when basket
    $(document).on('click', 'a', (e) => {
      const $currentTarget = $(e.currentTarget);
      const href = $currentTarget.attr('href');
      const target = $currentTarget.attr('target');
      const isButtonToOpenCottage = $currentTarget.hasClass('js-displayHousings');
      const isCancel = $currentTarget.hasClass('js-cancel');

      if (!isCancel && sessionStorage.getItem('basketDatas') !== null) {
        if (GLOBAL_SCRIPTS.CONTROLLER === 'product') {
          if (!(target === '_blank' || typeof href === 'undefined' || href.substring(0, 1) === '#' || href.indexOf('booking') > -1 || href.indexOf('search') > -1 || (href.indexOf('/fp_') > -1 && (href.split('/fp_')[1].substring(0, 2) === PRODUCT_SCRIPTS.PRODUCT_CODE)))) {
            e.preventDefault();
            this.openPopinWhenExitFp(e, href);
          }
        }
        if (GLOBAL_SCRIPTS.CONTROLLER === 'singleclick') {
          if (!(isButtonToOpenCottage || target === '_blank' || typeof href === 'undefined' || href.substring(0, 1) === '#' || href.indexOf('booking') > -1 || href.indexOf('search') > -1)) {
            e.preventDefault();
            this.openPopinWhenExitFp(e, href);
          }
        }
      }
    });
  },

  openPopinWhenExitFp: function (e, href) {
    e.preventDefault();

    if (!$(e.currentTarget).hasClass('js-confirm')) {
      const $body = $('body');
      const $popinCleanBasket = $('.popinCleanBasket');

      if ($popinCleanBasket.length) {
        $popinCleanBasket.remove();
      }

      $body.append(popinCleanBasketTpl({
        href: href,
        title: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.popinExitFpTitle,
        text: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.popinExitFpText,
        btn_confirm: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.popinExitFpConfirm,
        btn_cancel: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.popinExitFpCancel,
        origin: 'onExitFP'
      })).addClass('simplePopin');

      if (DEVICE.isMobile) {
        setTimeout(function () {
          $('.popinCleanBasket').addClass('open');
        }, 200);
      }

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Multicottage - popin exit park page',
        gaLabel: 'Popin display',
        event: 'popindisplay'
      });
    }

    this.eventPopins();
  },

  popinResetSearch(e) {
    e.preventDefault();
    const $popinCleanBasket = $('.popinCleanBasket');
    const facetteClicked = $(e.currentTarget).parents('.searchForm-capacity').length > 0 ? 'participants' : 'calendar';

    if ($popinCleanBasket.length) {
      $popinCleanBasket.remove();
    }

    $('body').append(popinCleanBasketTpl({
      href: false,
      title: GLOBAL_SCRIPTS.WORDINGS_COMMON.popinFocusSearchTitle,
      text: GLOBAL_SCRIPTS.WORDINGS_COMMON.popinFocusSearchText,
      btn_confirm: GLOBAL_SCRIPTS.WORDINGS_COMMON.popinFocusSearchConfirm,
      btn_cancel: GLOBAL_SCRIPTS.WORDINGS_COMMON.popinFocusSearchCancel,
      facetteToOpen: facetteClicked,
      origin: 'onClickSearch'
    })).addClass('simplePopin simplePopinResetSearch');

    if (DEVICE.isMobile) {
      setTimeout(function () {
        $('.popinCleanBasket').addClass('open');
      }, 200);
    }

    this.eventPopins();

    Tracking.dataLayerPush({
      clickCode: '',
      gaCategory: PAGE_SCRIPTS.page_template,
      gaAction: 'Multicottage - new search',
      gaLabel: 'Popin display',
      event: 'popindisplay'
    });
  },

  eventPopins() {
    $('.js-cancel, .popinCleanBasket .js-close').off().on('click', (e) => {
      e.preventDefault();
      const $body = $('body');
      const $popinCleanBasket = $('.popinCleanBasket');

      $('html').removeClass('disableScrollMenuMobile');
      $('.searchForm-inputContainer.opened').removeClass('opened');
      $('#js-searchEngine').removeClass('showCalendar');
      $body.removeClass('simplePopin simplePopinResetSearch searchFocused body-searchMobileEngineOpen body-searchMobileEngineOpened');

      if (DEVICE.isMobile && $body.hasClass('navDisplayed')) {
        $popinCleanBasket.removeClass('open');
        setTimeout(function () {
          $popinCleanBasket.remove();
          $('.js-header-open').click();
        }, 500);
      } else {
        $popinCleanBasket.remove();
      }

      const dataEvent = $(e.currentTarget).parents('.popinCleanBasket').data().event;
      const isPopinExit = dataEvent === 'onExitFP';
      const isNewSearch = dataEvent === 'onClickSearch';
      const isCloseIcon = $(e.currentTarget).hasClass('js-close');

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: isNewSearch ? 'Multicottage - new search' : isPopinExit ? 'Leave_#' + (typeof PRODUCT_SCRIPTS !== 'undefined' ? PRODUCT_SCRIPTS.SITENAME : '') : '',
        gaLabel: isCloseIcon ? 'Close Popin' : isNewSearch ? 'I\'m keeping my current selection' : isPopinExit ? 'No' : '',
        event: 'clickEvent'
      });
    });

    $('.js-confirmExit').off().on('click', (e) => {
      sessionStorage.removeItem('basketDatas');
      window.location.href = $(e.currentTarget).attr('href');

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Leave_#' + $('.basket-domainName').html(),
        gaLabel: 'yes',
        event: 'clickEvent'
      });
    });

    $('.js-confirm').off().on('click', (e) => {
      e.preventDefault();

      const $body = $('body');

      $('.popinCleanBasket, .basket-container, .basket-openerMobile').remove();
      $('html').removeClass('disableScrollMenuMobile');
      $body.removeClass('simplePopin simplePopinResetSearch searchFocused body-searchMobileEngineOpen body-searchMobileEngineOpened');
      sessionStorage.removeItem('basketDatas');

      setTimeout(function () {
        if (DEVICE.isMobile) {
          $('.js-searchForm-toggler').click();
          $('#mainContainer').addClass('searchEngineOpened');
        } else {
          const facetteToOpen = $(e.currentTarget).data().facettetoopen;

          dispatcher.trigger('facette:dates:resetDate');
          dispatcher.trigger('searchView:submitSearch');
          $body.addClass('searchFocused');

          if (facetteToOpen === 'participants') {
            $('.searchForm-capacity .js-displaySearchFormList.js-searchForm-dataOpener').click();
          } else {
            dispatcher.trigger('facette:dates:display', 'show', '.js-search-date_begin');
          }
        }
      }, 200);

      const isPopinExit = $(e.currentTarget).parents('.popinCleanBasket').data().event === 'onExitFP',
        isNewSearch = $(e.currentTarget).parents('.popinCleanBasket').data().event === 'onClickSearch',
        action = isNewSearch ? 'Multicottage - new search' : isPopinExit ? 'Leave_#' + PRODUCT_SCRIPTS.SITENAME : '',
        label = isNewSearch ? 'I confirm my new search' : isPopinExit ? 'yes' : '';

      Tracking.dataLayerPush({
        clickCode: '',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: action,
        gaLabel: label,
        event: 'clickEvent'
      });
    });
  }
});